import React from 'react';
import PropTypes from 'prop-types';
import { Box, Toolbar, CssBaseline } from '@mui/material';
import { useAuth } from '../../Hooks/useAuth';
import useWindowResize from '../../Hooks/useWindowResize';
import AppBar from './appBar';
import Drawer from './drawer';
import DrawerHeader from './drawerHeader';
import Sidebar from '../SideBar/sidebar';
import CustomHeader from '../../Layouts/Header/header';
import UserSession from '../../Utils/userSession';
import { useDrawer } from '../../Hooks/useDrawer';

const MainContentWrapper = ({ children }) => {
  const { loggedIn } = useAuth();
  const isDesktopView = useWindowResize();
  const {isOpen, toggleDrawer} = useDrawer();

  return loggedIn ? (
    <Box sx={{ display: 'flex', width: '100%', maxWidth: '100%' }}>
      <CssBaseline />
      <AppBar position="fixed" open={isOpen}>
        <Toolbar disableGutters>
          <CustomHeader handleDrawerOpen={toggleDrawer} open={isOpen} />
        </Toolbar>
      </AppBar>
      <Sidebar
        isOpen={isOpen}
        onToggle={toggleDrawer}
        screenWidth={isDesktopView}
        Drawer={Drawer}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
        }}
      >
        <DrawerHeader />
        <div style={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
          {children}
        </div>
      </Box>
      <UserSession/>
    </Box>
  ) : (
    <div>{children}</div>
  );
};

MainContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainContentWrapper;
